module.exports = __webpack_public_path__ + "img/img10.573e1c4a.svg";